export const users = {
  admin: {
    title: "Usuários",
  },
  error: {
    loading: "Erro ao carregar usuários",
  },
  history: {
    title: "Histórico de Usuários",
    empty: "Nenhum histórico de usuário encontrado",
    id: "ID",
    client: "Cliente",
    affiliateId: "ID do afiliado",
    actions: "Ações",
    subscription: "Assinatura",
  },
};
